import { Component, OnInit, Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { UserModel } from 'src/app/models/user.model';
import { UserHelper } from 'src/app/helpers/user';
import { AuthService } from 'src/app/services/auth.service';
import * as Cookies from 'js-cookie';
import { CommonHelper } from '../../../helpers/common';
import { MembershipsService } from 'src/app/services/memberships.service';

declare var $: any;
declare var AccountKit: any;
declare var FB: any;
declare var window: any;

@Injectable()
@Component({
  styleUrls: ['./footer.component.css'],
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  public get isVisibleCookiesPtl() {
    return this.commonHelper.isEnabledCookiesPtl;
  };
  public user: UserModel;
  public formRegister: UserModel;
  public formLogin: UserModel;
  public formRecoveryPassword: UserModel;
  public countries: object[];

  public AccountKit: any;
  public isRegister: boolean = false;
  public isLogin: boolean = true;
  public isRecoveryPassword = false;

  constructor(
    private commonHelper: CommonHelper,
    private auth: AuthService,
    private router: Router,
    private userHelper: UserHelper,
    private membership: MembershipsService) {
    this.countries = this.getCountries();
    this.getUser();
    // Cargamos el SDK de facebook de forma asynchronously
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    window.fbAsyncInit = function () {
      FB.init({
        appId: '2294170240821995',
        cookie: true, // enable cookies to allow the server to access
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v3.0'
      });
      FB.Event.subscribe('auth.authResponseChange', function (response) {
        //if (response.status === 'connected') { /*SUCCESS*/ }else if (response.status === 'not_authorized') { //FAILED 
        //} else { //UNKNOWN ERROR }
      });
    };
  }

  facebookLogin() {
    FB.login((response) => {
      if (response.authResponse) {
        FB.api('/me', 'post', { fields: ['email', "last_name", "first_name"] }, (response) => {
          this.auth.facebookLogin(response).subscribe(resp => {
            this.user = this.userHelper.getUser();
            $('.mfp-close').click();
            this.router.navigateByUrl('/home');
            window.location.reload(true);
          }, (err) => {
            console.log('FB Error: ', err);
          });
        });
      }
    }, { scope: 'email' });
  }

  ngOnInit() {
    this.formRegister = new UserModel();
    this.formLogin = new UserModel();
    this.formRecoveryPassword = new UserModel();
    this.fbLibrary();
  }

  registerSubmit(form: NgForm) {
    if (form.invalid) {
      console.log('form no valido!')
      return;
    }

    Swal.fire({
      allowOutsideClick: false,
      type: 'info',
      text: this.commonHelper.getTranslation('errors.pleaseWait')
    });
    Swal.showLoading();

    if (Cookies.get('affiliate_id')) {
      this.formRegister.affiliate_id = Cookies.get('affiliate_id').toString();
    }

    this.auth.register(this.formRegister).subscribe((request) => {

      Swal.close();
      $(".mfp-close").click();

      //1.- obtenemos la ubicacion
      this.auth.geolocation().subscribe((resp) => {
       
        //2.- obtenemos las membresias disponibles por país.
        this.membership.getByCountry(resp['response']['data'].name_en).subscribe((membership) => {

          this.membership = membership;
          this.router.navigateByUrl(`checkout/${this.membership['id']}`);

        }, (err) => {
          console.log("memberships exception:", err);
        });
      }, (err) => {
        console.log("geolocation exception:", err);
      });

    }, (err) => {
      Swal.close();

      var message = "";
      switch (err.status) {
        case 401:
          message = this.commonHelper.getTranslation('errors.emailIsRegistered');
          break;

        default:
          message = this.commonHelper.getTranslation('errors.serverError');
          break;
      }

      Swal.fire({
        type: 'error',
        text: message
      });

    });
  }

  loginSubmit(form: NgForm) {
    if (form.invalid) {
      console.log('form no valido!')
      return;
    }
    this.commonHelper.doLogin(this.formLogin,this.auth, this.userHelper, this.router);
  }
  accountKitLogin(): void {
    AccountKit.login('PHONE', { countryCode: '+52' },
      (response) => {
        this.loginCallback(response);
      }
    );
  }
  // phone form submission handler
  loginCallback(response) {

    if (response.status === "PARTIALLY_AUTHENTICATED") {
      var code = response.code;
      var csrf = response.state;

      this.auth.smsLogin(code).subscribe(resp => {
        this.user = this.userHelper.getUser();
        this.router.navigateByUrl('/home');
        $('.mfp-close').click();
      }, (err) => {
        console.log('AccountKit Error: ', err);
      });

    }
    else if (response.status === "NOT_AUTHENTICATED") {
      // handle authentication failure
    }
    else if (response.status === "BAD_PARAMS") {
      // handle bad parameters
    }

  }

  initLogin() {
    this.isLogin = true;
    this.isRecoveryPassword = false;
  }

  displayRegisterForm() {
    this.isRegister = true;
    this.isLogin = false;
    this.isRecoveryPassword = false;
  }

  displayRecoveryForm() {
    this.isRegister = false;
    this.isLogin = false;
    this.isRecoveryPassword = true;
  }

  displayLoginForm(){
    this.isRegister = false;
    this.isLogin = true;
    this.isRecoveryPassword = false;
  }

  initRegister() {
    this.isRegister = !this.isRegister;
    this.isLogin = !this.isLogin;
  }

  initRecoveryPassword() {
    if (this.formLogin.email != "") {
      this.formRecoveryPassword.email = this.formLogin.email;
    }

    this.isRecoveryPassword = !this.isRecoveryPassword;
    this.isLogin = !this.isRecoveryPassword;
  }

  recoveryPasswordSubmit(form: NgForm) {
    if (form.invalid) {
      console.log('form no valido!')
      return;
    }

    console.log('Enviando mensaje!');
    Swal.fire({
      allowOutsideClick: false,
      type: 'info',
      text: this.commonHelper.getTranslation('errors.pleaseWait')
    });
    Swal.showLoading();

    this.auth.recoveryPassword(this.formRecoveryPassword).subscribe((resp) => {
      console.log('Mensaje enviado!', resp);
      Swal.close();

      Swal.fire({
        type: 'success',
        text: this.commonHelper.getTranslation('errors.sendingMail')
      });

    }, (err) => {
      console.log('Mensaje no enviado!', err);
      Swal.close();

      var message = "";
      switch (err.status) {
        case 400:
          message = this.commonHelper.getTranslation('errors.serverError');
          break;
        case 403:
          message = this.commonHelper.getTranslation('errors.serverError');
          break;

        default:
          message = this.commonHelper.getTranslation('errors.serverError');
          break;
      }

      Swal.fire({
        type: 'error',
        text: message
      });

    });
  }

  getCountries(): object[] {
    console.log("Cambiando lenguaje", localStorage.getItem("lang"));

    if (localStorage.getItem("lang") == 'es') {
      return [
        { 'name': 'Afganistán', 'abbrev': 'AFG' }
        , { 'name': 'Albania', 'abbrev': 'ALB' }
        , { 'name': 'Alemania', 'abbrev': 'DEU' }
        , { 'name': 'Algeria', 'abbrev': 'DZA' }
        , { 'name': 'Andorra', 'abbrev': 'AND' }
        , { 'name': 'Angola', 'abbrev': 'AGO' }
        , { 'name': 'Anguila', 'abbrev': 'AIA' }
        , { 'name': 'Antártida', 'abbrev': 'ATA' }
        , { 'name': 'Antigua y Barbuda', 'abbrev': 'ATG' }
        , { 'name': 'Antillas Neerlandesas', 'abbrev': 'ANT' }
        , { 'name': 'Arabia Saudita', 'abbrev': 'SAU' }
        , { 'name': 'Argentina', 'abbrev': 'ARG' }
        , { 'name': 'Armenia', 'abbrev': 'ARM' }
        , { 'name': 'Aruba', 'abbrev': 'ABW' }
        , { 'name': 'Australia', 'abbrev': 'AUS' }
        , { 'name': 'Austria', 'abbrev': 'AUT' }
        , { 'name': 'Azerbayán', 'abbrev': 'AZE' }
        , { 'name': 'Bélgica', 'abbrev': 'BEL' }
        , { 'name': 'Bahamas', 'abbrev': 'BHS' }
        , { 'name': 'Bahrein', 'abbrev': 'BHR' }
        , { 'name': 'Bangladesh', 'abbrev': 'BGD' }
        , { 'name': 'Barbados', 'abbrev': 'BRB' }
        , { 'name': 'Belice', 'abbrev': 'BLZ' }
        , { 'name': 'Benín', 'abbrev': 'BEN' }
        , { 'name': 'Bhután', 'abbrev': 'BTN' }
        , { 'name': 'Bielorrusia', 'abbrev': 'BLR' }
        , { 'name': 'Birmania', 'abbrev': 'MMR' }
        , { 'name': 'Bolivia', 'abbrev': 'BOL' }
        , { 'name': 'Bosnia y Herzegovina', 'abbrev': 'BIH' }
        , { 'name': 'Botsuana', 'abbrev': 'BWA' }
        , { 'name': 'Brasil', 'abbrev': 'BRA' }
        , { 'name': 'Brunéi', 'abbrev': 'BRN' }
        , { 'name': 'Bulgaria', 'abbrev': 'BGR' }
        , { 'name': 'Burkina Faso', 'abbrev': 'BFA' }
        , { 'name': 'Burundi', 'abbrev': 'BDI' }
        , { 'name': 'Cabo Verde', 'abbrev': 'CPV' }
        , { 'name': 'Camboya', 'abbrev': 'KHM' }
        , { 'name': 'Camerún', 'abbrev': 'CMR' }
        , { 'name': 'Canadá', 'abbrev': 'CAN' }
        , { 'name': 'Chad', 'abbrev': 'TCD' }
        , { 'name': 'Chile', 'abbrev': 'CHL' }
        , { 'name': 'China', 'abbrev': 'CHN' }
        , { 'name': 'Chipre', 'abbrev': 'CYP' }
        , { 'name': 'Ciudad del Vaticano', 'abbrev': 'VAT' }
        , { 'name': 'Colombia', 'abbrev': 'COL' }
        , { 'name': 'Comoras', 'abbrev': 'COM' }
        , { 'name': 'Congo', 'abbrev': 'COG' }
        , { 'name': 'Congo', 'abbrev': 'COD' }
        , { 'name': 'Corea del Norte', 'abbrev': 'PRK' }
        , { 'name': 'Corea del Sur', 'abbrev': 'KOR' }
        , { 'name': 'Costa de Marfil', 'abbrev': 'CIV' }
        , { 'name': 'Costa Rica', 'abbrev': 'CRI' }
        , { 'name': 'Croacia', 'abbrev': 'HRV' }
        , { 'name': 'Cuba', 'abbrev': 'CUB' }
        , { 'name': 'Dinamarca', 'abbrev': 'DNK' }
        , { 'name': 'Dominica', 'abbrev': 'DMA' }
        , { 'name': 'Ecuador', 'abbrev': 'ECU' }
        , { 'name': 'Egipto', 'abbrev': 'EGY' }
        , { 'name': 'El Salvador', 'abbrev': 'SLV' }
        , { 'name': 'Emiratos Árabes Unidos', 'abbrev': 'ARE' }
        , { 'name': 'Eritrea', 'abbrev': 'ERI' }
        , { 'name': 'Eslovaquia', 'abbrev': 'SVK' }
        , { 'name': 'Eslovenia', 'abbrev': 'SVN' }
        , { 'name': 'España', 'abbrev': 'ESP' }
        , { 'name': 'Estados Unidos de América', 'abbrev': 'USA' }
        , { 'name': 'Estonia', 'abbrev': 'EST' }
        , { 'name': 'Etiopía', 'abbrev': 'ETH' }
        , { 'name': 'Filipinas', 'abbrev': 'PHL' }
        , { 'name': 'Finlandia', 'abbrev': 'FIN' }
        , { 'name': 'Fiyi', 'abbrev': 'FJI' }
        , { 'name': 'Francia', 'abbrev': 'FRA' }
        , { 'name': 'Gabón', 'abbrev': 'GAB' }
        , { 'name': 'Gambia', 'abbrev': 'GMB' }
        , { 'name': 'Georgia', 'abbrev': 'GEO' }
        , { 'name': 'Ghana', 'abbrev': 'GHA' }
        , { 'name': 'Gibraltar', 'abbrev': 'GIB' }
        , { 'name': 'Granada', 'abbrev': 'GRD' }
        , { 'name': 'Grecia', 'abbrev': 'GRC' }
        , { 'name': 'Groenlandia', 'abbrev': 'GRL' }
        , { 'name': 'Guadalupe', 'abbrev': 'GLP' }
        , { 'name': 'Guam', 'abbrev': 'GUM' }
        , { 'name': 'Guatemala', 'abbrev': 'GTM' }
        , { 'name': 'Guayana Francesa', 'abbrev': 'GUF' }
        , { 'name': 'Guernsey', 'abbrev': 'GGY' }
        , { 'name': 'Guinea', 'abbrev': 'GIN' }
        , { 'name': 'Guinea Ecuatorial', 'abbrev': 'GNQ' }
        , { 'name': 'Guinea-Bissau', 'abbrev': 'GNB' }
        , { 'name': 'Guyana', 'abbrev': 'GUY' }
        , { 'name': 'Haití', 'abbrev': 'HTI' }
        , { 'name': 'Honduras', 'abbrev': 'HND' }
        , { 'name': 'Hong kong', 'abbrev': 'HKG' }
        , { 'name': 'Hungría', 'abbrev': 'HUN' }
        , { 'name': 'India', 'abbrev': 'IND' }
        , { 'name': 'Indonesia', 'abbrev': 'IDN' }
        , { 'name': 'Irán', 'abbrev': 'IRN' }
        , { 'name': 'Irak', 'abbrev': 'IRQ' }
        , { 'name': 'Irlanda', 'abbrev': 'IRL' }
        , { 'name': 'Isla Bouvet', 'abbrev': 'BVT' }
        , { 'name': 'Isla de Man', 'abbrev': 'IMN' }
        , { 'name': 'Isla de Navidad', 'abbrev': 'CXR' }
        , { 'name': 'Isla Norfolk', 'abbrev': 'NFK' }
        , { 'name': 'Islandia', 'abbrev': 'ISL' }
        , { 'name': 'Islas Bermudas', 'abbrev': 'BMU' }
        , { 'name': 'Islas Caimán', 'abbrev': 'CYM' }
        , { 'name': 'Islas Cocos (Keeling)', 'abbrev': 'CCK' }
        , { 'name': 'Islas Cook', 'abbrev': 'COK' }
        , { 'name': 'Islas de Åland', 'abbrev': 'ALA' }
        , { 'name': 'Islas Feroe', 'abbrev': 'FRO' }
        , { 'name': 'Islas Georgias del Sur y Sandwich del Sur', 'abbrev': 'SGS' }
        , { 'name': 'Islas Heard y McDonald', 'abbrev': 'HMD' }
        , { 'name': 'Islas Maldivas', 'abbrev': 'MDV' }
        , { 'name': 'Islas Malvinas', 'abbrev': 'FLK' }
        , { 'name': 'Islas Marianas del Norte', 'abbrev': 'MNP' }
        , { 'name': 'Islas Marshall', 'abbrev': 'MHL' }
        , { 'name': 'Islas Pitcairn', 'abbrev': 'PCN' }
        , { 'name': 'Islas Salomón', 'abbrev': 'SLB' }
        , { 'name': 'Islas Turcas y Caicos', 'abbrev': 'TCA' }
        , { 'name': 'Islas Ultramarinas Menores de Estados Unidos', 'abbrev': 'UMI' }
        , { 'name': 'Islas Vírgenes Británicas', 'abbrev': 'VG' }
        , { 'name': 'Islas Vírgenes de los Estados Unidos', 'abbrev': 'VIR' }
        , { 'name': 'Israel', 'abbrev': 'ISR' }
        , { 'name': 'Italia', 'abbrev': 'ITA' }
        , { 'name': 'Jamaica', 'abbrev': 'JAM' }
        , { 'name': 'Japón', 'abbrev': 'JPN' }
        , { 'name': 'Jersey', 'abbrev': 'JEY' }
        , { 'name': 'Jordania', 'abbrev': 'JOR' }
        , { 'name': 'Kazajistán', 'abbrev': 'KAZ' }
        , { 'name': 'Kenia', 'abbrev': 'KEN' }
        , { 'name': 'Kirgizstán', 'abbrev': 'KGZ' }
        , { 'name': 'Kiribati', 'abbrev': 'KIR' }
        , { 'name': 'Kuwait', 'abbrev': 'KWT' }
        , { 'name': 'Líbano', 'abbrev': 'LBN' }
        , { 'name': 'Laos', 'abbrev': 'LAO' }
        , { 'name': 'Lesoto', 'abbrev': 'LSO' }
        , { 'name': 'Letonia', 'abbrev': 'LVA' }
        , { 'name': 'Liberia', 'abbrev': 'LBR' }
        , { 'name': 'Libia', 'abbrev': 'LBY' }
        , { 'name': 'Liechtenstein', 'abbrev': 'LIE' }
        , { 'name': 'Lituania', 'abbrev': 'LTU' }
        , { 'name': 'Luxemburgo', 'abbrev': 'LUX' }
        , { 'name': 'México', 'abbrev': 'MEX' }
        , { 'name': 'Mónaco', 'abbrev': 'MCO' }
        , { 'name': 'Macao', 'abbrev': 'MAC' }
        , { 'name': 'Macedônia', 'abbrev': 'MKD' }
        , { 'name': 'Madagascar', 'abbrev': 'MDG' }
        , { 'name': 'Malasia', 'abbrev': 'MYS' }
        , { 'name': 'Malawi', 'abbrev': 'MWI' }
        , { 'name': 'Mali', 'abbrev': 'MLI' }
        , { 'name': 'Malta', 'abbrev': 'MLT' }
        , { 'name': 'Marruecos', 'abbrev': 'MAR' }
        , { 'name': 'Martinica', 'abbrev': 'MTQ' }
        , { 'name': 'Mauricio', 'abbrev': 'MUS' }
        , { 'name': 'Mauritania', 'abbrev': 'MRT' }
        , { 'name': 'Mayotte', 'abbrev': 'MYT' }
        , { 'name': 'Micronesia', 'abbrev': 'FSM' }
        , { 'name': 'Moldavia', 'abbrev': 'MDA' }
        , { 'name': 'Mongolia', 'abbrev': 'MNG' }
        , { 'name': 'Montenegro', 'abbrev': 'MNE' }
        , { 'name': 'Montserrat', 'abbrev': 'MSR' }
        , { 'name': 'Mozambique', 'abbrev': 'MOZ' }
        , { 'name': 'Namibia', 'abbrev': 'NAM' }
        , { 'name': 'Nauru', 'abbrev': 'NRU' }
        , { 'name': 'Nepal', 'abbrev': 'NPL' }
        , { 'name': 'Nicaragua', 'abbrev': 'NIC' }
        , { 'name': 'Niger', 'abbrev': 'NER' }
        , { 'name': 'Nigeria', 'abbrev': 'NGA' }
        , { 'name': 'Niue', 'abbrev': 'NIU' }
        , { 'name': 'Noruega', 'abbrev': 'NOR' }
        , { 'name': 'Nueva Caledonia', 'abbrev': 'NCL' }
        , { 'name': 'Nueva Zelanda', 'abbrev': 'NZL' }
        , { 'name': 'Omán', 'abbrev': 'OMN' }
        , { 'name': 'Países Bajos', 'abbrev': 'NLD' }
        , { 'name': 'Pakistán', 'abbrev': 'PAK' }
        , { 'name': 'Palau', 'abbrev': 'PLW' }
        , { 'name': 'Palestina', 'abbrev': 'PSE' }
        , { 'name': 'Panamá', 'abbrev': 'PAN' }
        , { 'name': 'Papúa Nueva Guinea', 'abbrev': 'PNG' }
        , { 'name': 'Paraguay', 'abbrev': 'PRY' }
        , { 'name': 'Perú', 'abbrev': 'PER' }
        , { 'name': 'Polinesia Francesa', 'abbrev': 'PYF' }
        , { 'name': 'Polonia', 'abbrev': 'POL' }
        , { 'name': 'Portugal', 'abbrev': 'PRT' }
        , { 'name': 'Puerto Rico', 'abbrev': 'PRI' }
        , { 'name': 'Qatar', 'abbrev': 'QAT' }
        , { 'name': 'Reino Unido', 'abbrev': 'GBR' }
        , { 'name': 'República Centroafricana', 'abbrev': 'CAF' }
        , { 'name': 'República Checa', 'abbrev': 'CZE' }
        , { 'name': 'República Dominicana', 'abbrev': 'DOM' }
        , { 'name': 'Reunión', 'abbrev': 'REU' }
        , { 'name': 'Ruanda', 'abbrev': 'RWA' }
        , { 'name': 'Rumanía', 'abbrev': 'ROU' }
        , { 'name': 'Rusia', 'abbrev': 'RUS' }
        , { 'name': 'Sahara Occidental', 'abbrev': 'ESH' }
        , { 'name': 'Samoa', 'abbrev': 'WSM' }
        , { 'name': 'Samoa Americana', 'abbrev': 'ASM' }
        , { 'name': 'San Bartolomé', 'abbrev': 'BLM' }
        , { 'name': 'San Cristóbal y Nieves', 'abbrev': 'KNA' }
        , { 'name': 'San Marino', 'abbrev': 'SMR' }
        , { 'name': 'San Martín (Francia)', 'abbrev': 'MAF' }
        , { 'name': 'San Pedro y Miquelón', 'abbrev': 'SPM' }
        , { 'name': 'San Vicente y las Granadinas', 'abbrev': 'VCT' }
        , { 'name': 'Santa Elena', 'abbrev': 'SHN' }
        , { 'name': 'Santa Lucía', 'abbrev': 'LCA' }
        , { 'name': 'Santo Tomé y Príncipe', 'abbrev': 'STP' }
        , { 'name': 'Senegal', 'abbrev': 'SEN' }
        , { 'name': 'Serbia', 'abbrev': 'SRB' }
        , { 'name': 'Seychelles', 'abbrev': 'SYC' }
        , { 'name': 'Sierra Leona', 'abbrev': 'SLE' }
        , { 'name': 'Singapur', 'abbrev': 'SGP' }
        , { 'name': 'Siria', 'abbrev': 'SYR' }
        , { 'name': 'Somalia', 'abbrev': 'SOM' }
        , { 'name': 'Sri lanka', 'abbrev': 'LKA' }
        , { 'name': 'Sudáfrica', 'abbrev': 'ZAF' }
        , { 'name': 'Sudán', 'abbrev': 'SDN' }
        , { 'name': 'Suecia', 'abbrev': 'SWE' }
        , { 'name': 'Suiza', 'abbrev': 'CHE' }
        , { 'name': 'Surinám', 'abbrev': 'SUR' }
        , { 'name': 'Svalbard y Jan Mayen', 'abbrev': 'SJM' }
        , { 'name': 'Swazilandia', 'abbrev': 'SWZ' }
        , { 'name': 'Tadjikistán', 'abbrev': 'TJK' }
        , { 'name': 'Tailandia', 'abbrev': 'THA' }
        , { 'name': 'Taiwán', 'abbrev': 'TWN' }
        , { 'name': 'Tanzania', 'abbrev': 'TZA' }
        , { 'name': 'Territorio Británico del Océano Índico', 'abbrev': 'IOT' }
        , { 'name': 'Territorios Australes y Antárticas Franceses', 'abbrev': 'ATF' }
        , { 'name': 'Timor Oriental', 'abbrev': 'TLS' }
        , { 'name': 'Togo', 'abbrev': 'TGO' }
        , { 'name': 'Tokelau', 'abbrev': 'TKL' }
        , { 'name': 'Tonga', 'abbrev': 'TON' }
        , { 'name': 'Trinidad y Tobago', 'abbrev': 'TTO' }
        , { 'name': 'Tunez', 'abbrev': 'TUN' }
        , { 'name': 'Turkmenistán', 'abbrev': 'TKM' }
        , { 'name': 'Turquía', 'abbrev': 'TUR' }
        , { 'name': 'Tuvalu', 'abbrev': 'TUV' }
        , { 'name': 'Ucrania', 'abbrev': 'UKR' }
        , { 'name': 'Uganda', 'abbrev': 'UGA' }
        , { 'name': 'Uruguay', 'abbrev': 'URY' }
        , { 'name': 'Uzbekistán', 'abbrev': 'UZB' }
        , { 'name': 'Vanuatu', 'abbrev': 'VUT' }
        , { 'name': 'Venezuela', 'abbrev': 'VEN' }
        , { 'name': 'Vietnam', 'abbrev': 'VNM' }
        , { 'name': 'Wallis y Futuna', 'abbrev': 'WLF' }
        , { 'name': 'Yemen', 'abbrev': 'YEM' }
        , { 'name': 'Yibuti', 'abbrev': 'DJI' }
        , { 'name': 'Zambia', 'abbrev': 'ZMB' }
        , { 'name': 'Zimbabue', 'abbrev': 'ZWE' }
      ];
    } else {
      return [
        { 'name': 'Afghanistan', 'abbrev': 'AFG' }
        , { 'name': 'Albania', 'abbrev': 'ALB' }
        , { 'name': 'Germany', 'abbrev': 'DEU' }
        , { 'name': 'Algeria', 'abbrev': 'DZA' }
        , { 'name': 'Andorra', 'abbrev': 'AND' }
        , { 'name': 'Angola', 'abbrev': 'AGO' }
        , { 'name': 'Anguilla', 'abbrev': 'AIA' }
        , { 'name': 'Antarctica', 'abbrev': 'ATA' }
        , { 'name': 'Antigua and Barbuda', 'abbrev': 'ATG' }
        , { 'name': 'Netherlands Antilles', 'abbrev': 'ANT' }
        , { 'name': 'Saudi Arabia', 'abbrev': 'SAU' }
        , { 'name': 'Argentina', 'abbrev': 'ARG' }
        , { 'name': 'Armenia', 'abbrev': 'ARM' }
        , { 'name': 'Aruba', 'abbrev': 'ABW' }
        , { 'name': 'Australia', 'abbrev': 'AUS' }
        , { 'name': 'Austria', 'abbrev': 'AUT' }
        , { 'name': 'Azerbaijan', 'abbrev': 'AZE' }
        , { 'name': 'Belgium', 'abbrev': 'BEL' }
        , { 'name': 'Bahamas', 'abbrev': 'BHS' }
        , { 'name': 'Bahrain', 'abbrev': 'BHR' }
        , { 'name': 'Bangladesh', 'abbrev': 'BGD' }
        , { 'name': 'Barbados', 'abbrev': 'BRB' }
        , { 'name': 'Belize', 'abbrev': 'BLZ' }
        , { 'name': 'Benin', 'abbrev': 'BEN' }
        , { 'name': 'Bhutan', 'abbrev': 'BTN' }
        , { 'name': 'Belarus', 'abbrev': 'BLR' }
        , { 'name': 'Myanmar', 'abbrev': 'MMR' }
        , { 'name': 'Bolivia', 'abbrev': 'BOL' }
        , { 'name': 'Bosnia and Herzegovina', 'abbrev': 'BIH' }
        , { 'name': 'Botswana', 'abbrev': 'BWA' }
        , { 'name': 'Brazil', 'abbrev': 'BRA' }
        , { 'name': 'Brunei', 'abbrev': 'BRN' }
        , { 'name': 'Bulgaria', 'abbrev': 'BGR' }
        , { 'name': 'Burkina Faso', 'abbrev': 'BFA' }
        , { 'name': 'Burundi', 'abbrev': 'BDI' }
        , { 'name': 'Cape Verde', 'abbrev': 'CPV' }
        , { 'name': 'Cambodia', 'abbrev': 'KHM' }
        , { 'name': 'Cameroon', 'abbrev': 'CMR' }
        , { 'name': 'Canada', 'abbrev': 'CAN' }
        , { 'name': 'Chad', 'abbrev': 'TCD' }
        , { 'name': 'Chile', 'abbrev': 'CHL' }
        , { 'name': 'China', 'abbrev': 'CHN' }
        , { 'name': 'Cyprus', 'abbrev': 'CYP' }
        , { 'name': 'Vatican City State', 'abbrev': 'VAT' }
        , { 'name': 'Colombia', 'abbrev': 'COL' }
        , { 'name': 'Comoros', 'abbrev': 'COM' }
        , { 'name': 'Congo', 'abbrev': 'COG' }
        , { 'name': 'Congo', 'abbrev': 'COD' }
        , { 'name': 'North Korea', 'abbrev': 'PRK' }
        , { 'name': 'South Korea', 'abbrev': 'KOR' }
        , { 'name': 'Ivory Coast', 'abbrev': 'CIV' }
        , { 'name': 'Costa Rica', 'abbrev': 'CRI' }
        , { 'name': 'Croatia', 'abbrev': 'HRV' }
        , { 'name': 'Cuba', 'abbrev': 'CUB' }
        , { 'name': 'Denmark', 'abbrev': 'DNK' }
        , { 'name': 'Dominica', 'abbrev': 'DMA' }
        , { 'name': 'Ecuador', 'abbrev': 'ECU' }
        , { 'name': 'Egypt', 'abbrev': 'EGY' }
        , { 'name': 'El Salvador', 'abbrev': 'SLV' }
        , { 'name': 'United Arab Emirates', 'abbrev': 'ARE' }
        , { 'name': 'Eritrea', 'abbrev': 'ERI' }
        , { 'name': 'Slovakia', 'abbrev': 'SVK' }
        , { 'name': 'Slovenia', 'abbrev': 'SVN' }
        , { 'name': 'Spain', 'abbrev': 'ESP' }
        , { 'name': 'United States of America', 'abbrev': 'USA' }
        , { 'name': 'Estonia', 'abbrev': 'EST' }
        , { 'name': 'Ethiopia', 'abbrev': 'ETH' }
        , { 'name': 'Philippines', 'abbrev': 'PHL' }
        , { 'name': 'Finland', 'abbrev': 'FIN' }
        , { 'name': 'Fiji', 'abbrev': 'FJI' }
        , { 'name': 'France', 'abbrev': 'FRA' }
        , { 'name': 'Gabon', 'abbrev': 'GAB' }
        , { 'name': 'Gambia', 'abbrev': 'GMB' }
        , { 'name': 'Georgia', 'abbrev': 'GEO' }
        , { 'name': 'Ghana', 'abbrev': 'GHA' }
        , { 'name': 'Gibraltar', 'abbrev': 'GIB' }
        , { 'name': 'Grenada', 'abbrev': 'GRD' }
        , { 'name': 'Greece', 'abbrev': 'GRC' }
        , { 'name': 'Greenland', 'abbrev': 'GRL' }
        , { 'name': 'Guadeloupe', 'abbrev': 'GLP' }
        , { 'name': 'Guam', 'abbrev': 'GUM' }
        , { 'name': 'Guatemala', 'abbrev': 'GTM' }
        , { 'name': 'French Guiana', 'abbrev': 'GUF' }
        , { 'name': 'Guernsey', 'abbrev': 'GGY' }
        , { 'name': 'Guinea', 'abbrev': 'GIN' }
        , { 'name': 'Equatorial Guinea', 'abbrev': 'GNQ' }
        , { 'name': 'Guinea-Bissau', 'abbrev': 'GNB' }
        , { 'name': 'Guyana', 'abbrev': 'GUY' }
        , { 'name': 'Haiti', 'abbrev': 'HTI' }
        , { 'name': 'Honduras', 'abbrev': 'HND' }
        , { 'name': 'Hong Kong', 'abbrev': 'HKG' }
        , { 'name': 'Hungary', 'abbrev': 'HUN' }
        , { 'name': 'India', 'abbrev': 'IND' }
        , { 'name': 'Indonesia', 'abbrev': 'IDN' }
        , { 'name': 'Iran', 'abbrev': 'IRN' }
        , { 'name': 'Iraq', 'abbrev': 'IRQ' }
        , { 'name': 'Ireland', 'abbrev': 'IRL' }
        , { 'name': 'Bouvet Island', 'abbrev': 'BVT' }
        , { 'name': 'Isle of Man', 'abbrev': 'IMN' }
        , { 'name': 'Christmas Island', 'abbrev': 'CXR' }
        , { 'name': 'Norfolk Island', 'abbrev': 'NFK' }
        , { 'name': 'Iceland', 'abbrev': 'ISL' }
        , { 'name': 'Bermuda Islands', 'abbrev': 'BMU' }
        , { 'name': 'Cayman Islands', 'abbrev': 'CYM' }
        , { 'name': 'Cocos (Keeling) Islands', 'abbrev': 'CCK' }
        , { 'name': 'Cook Islands', 'abbrev': 'COK' }
        , { 'name': 'Åland Islands', 'abbrev': 'ALA' }
        , { 'name': 'Faroe Islands', 'abbrev': 'FRO' }
        , { 'name': 'South Georgia and the South Sandwich Islands', 'abbrev': 'SGS' }
        , { 'name': 'Heard Island and McDonald Islands', 'abbrev': 'HMD' }
        , { 'name': 'Maldives', 'abbrev': 'MDV' }
        , { 'name': 'Falkland Islands (Malvinas)', 'abbrev': 'FLK' }
        , { 'name': 'Northern Mariana Islands', 'abbrev': 'MNP' }
        , { 'name': 'Marshall Islands', 'abbrev': 'MHL' }
        , { 'name': 'Pitcairn Islands', 'abbrev': 'PCN' }
        , { 'name': 'Solomon Islands', 'abbrev': 'SLB' }
        , { 'name': 'Turks and Caicos Islands', 'abbrev': 'TCA' }
        , { 'name': 'United States Minor Outlying Islands', 'abbrev': 'UMI' }
        , { 'name': 'Virgin Islands', 'abbrev': 'VG' }
        , { 'name': 'United States Virgin Islands', 'abbrev': 'VIR' }
        , { 'name': 'Israel', 'abbrev': 'ISR' }
        , { 'name': 'Italy', 'abbrev': 'ITA' }
        , { 'name': 'Jamaica', 'abbrev': 'JAM' }
        , { 'name': 'Japan', 'abbrev': 'JPN' }
        , { 'name': 'Jersey', 'abbrev': 'JEY' }
        , { 'name': 'Jordan', 'abbrev': 'JOR' }
        , { 'name': 'Kazakhstan', 'abbrev': 'KAZ' }
        , { 'name': 'Kenya', 'abbrev': 'KEN' }
        , { 'name': 'Kyrgyzstan', 'abbrev': 'KGZ' }
        , { 'name': 'Kiribati', 'abbrev': 'KIR' }
        , { 'name': 'Kuwait', 'abbrev': 'KWT' }
        , { 'name': 'Lebanon', 'abbrev': 'LBN' }
        , { 'name': 'Laos', 'abbrev': 'LAO' }
        , { 'name': 'Lesotho', 'abbrev': 'LSO' }
        , { 'name': 'Latvia', 'abbrev': 'LVA' }
        , { 'name': 'Liberia', 'abbrev': 'LBR' }
        , { 'name': 'Libya', 'abbrev': 'LBY' }
        , { 'name': 'Liechtenstein', 'abbrev': 'LIE' }
        , { 'name': 'Lithuania', 'abbrev': 'LTU' }
        , { 'name': 'Luxembourg', 'abbrev': 'LUX' }
        , { 'name': 'Mexico', 'abbrev': 'MEX' }
        , { 'name': 'Monaco', 'abbrev': 'MCO' }
        , { 'name': 'Macao', 'abbrev': 'MAC' }
        , { 'name': 'Macedonia', 'abbrev': 'MKD' }
        , { 'name': 'Madagascar', 'abbrev': 'MDG' }
        , { 'name': 'Malaysia', 'abbrev': 'MYS' }
        , { 'name': 'Malawi', 'abbrev': 'MWI' }
        , { 'name': 'Mali', 'abbrev': 'MLI' }
        , { 'name': 'Malta', 'abbrev': 'MLT' }
        , { 'name': 'Morocco', 'abbrev': 'MAR' }
        , { 'name': 'Martinique', 'abbrev': 'MTQ' }
        , { 'name': 'Mauritius', 'abbrev': 'MUS' }
        , { 'name': 'Mauritania', 'abbrev': 'MRT' }
        , { 'name': 'Mayotte', 'abbrev': 'MYT' }
        , { 'name': 'Estados Federados de', 'abbrev': 'FSM' }
        , { 'name': 'Moldova', 'abbrev': 'MDA' }
        , { 'name': 'Mongolia', 'abbrev': 'MNG' }
        , { 'name': 'Montenegro', 'abbrev': 'MNE' }
        , { 'name': 'Montserrat', 'abbrev': 'MSR' }
        , { 'name': 'Mozambique', 'abbrev': 'MOZ' }
        , { 'name': 'Namibia', 'abbrev': 'NAM' }
        , { 'name': 'Nauru', 'abbrev': 'NRU' }
        , { 'name': 'Nepal', 'abbrev': 'NPL' }
        , { 'name': 'Nicaragua', 'abbrev': 'NIC' }
        , { 'name': 'Niger', 'abbrev': 'NER' }
        , { 'name': 'Nigeria', 'abbrev': 'NGA' }
        , { 'name': 'Niue', 'abbrev': 'NIU' }
        , { 'name': 'Norway', 'abbrev': 'NOR' }
        , { 'name': 'New Caledonia', 'abbrev': 'NCL' }
        , { 'name': 'New Zealand', 'abbrev': 'NZL' }
        , { 'name': 'Oman', 'abbrev': 'OMN' }
        , { 'name': 'Netherlands', 'abbrev': 'NLD' }
        , { 'name': 'Pakistan', 'abbrev': 'PAK' }
        , { 'name': 'Palau', 'abbrev': 'PLW' }
        , { 'name': 'Palestine', 'abbrev': 'PSE' }
        , { 'name': 'Panama', 'abbrev': 'PAN' }
        , { 'name': 'Papua New Guinea', 'abbrev': 'PNG' }
        , { 'name': 'Paraguay', 'abbrev': 'PRY' }
        , { 'name': 'Peru', 'abbrev': 'PER' }
        , { 'name': 'French Polynesia', 'abbrev': 'PYF' }
        , { 'name': 'Poland', 'abbrev': 'POL' }
        , { 'name': 'Portugal', 'abbrev': 'PRT' }
        , { 'name': 'Puerto Rico', 'abbrev': 'PRI' }
        , { 'name': 'Qatar', 'abbrev': 'QAT' }
        , { 'name': 'United Kingdom', 'abbrev': 'GBR' }
        , { 'name': 'Central African Republic', 'abbrev': 'CAF' }
        , { 'name': 'Czech Republic', 'abbrev': 'CZE' }
        , { 'name': 'Dominican Republic', 'abbrev': 'DOM' }
        , { 'name': 'Réunion', 'abbrev': 'REU' }
        , { 'name': 'Rwanda', 'abbrev': 'RWA' }
        , { 'name': 'Romania', 'abbrev': 'ROU' }
        , { 'name': 'Russia', 'abbrev': 'RUS' }
        , { 'name': 'Western Sahara', 'abbrev': 'ESH' }
        , { 'name': 'Samoa', 'abbrev': 'WSM' }
        , { 'name': 'American Samoa', 'abbrev': 'ASM' }
        , { 'name': 'Saint Barthélemy', 'abbrev': 'BLM' }
        , { 'name': 'Saint Kitts and Nevis', 'abbrev': 'KNA' }
        , { 'name': 'San Marino', 'abbrev': 'SMR' }
        , { 'name': 'Saint Martin (French part)', 'abbrev': 'MAF' }
        , { 'name': 'Saint Pierre and Miquelon', 'abbrev': 'SPM' }
        , { 'name': 'Saint Vincent and the Grenadines', 'abbrev': 'VCT' }
        , { 'name': 'Ascensión y Tristán de Acuña', 'abbrev': 'SHN' }
        , { 'name': 'Saint Lucia', 'abbrev': 'LCA' }
        , { 'name': 'Sao Tome and Principe', 'abbrev': 'STP' }
        , { 'name': 'Senegal', 'abbrev': 'SEN' }
        , { 'name': 'Serbia', 'abbrev': 'SRB' }
        , { 'name': 'Seychelles', 'abbrev': 'SYC' }
        , { 'name': 'Sierra Leone', 'abbrev': 'SLE' }
        , { 'name': 'Singapore', 'abbrev': 'SGP' }
        , { 'name': 'Syria', 'abbrev': 'SYR' }
        , { 'name': 'Somalia', 'abbrev': 'SOM' }
        , { 'name': 'Sri Lanka', 'abbrev': 'LKA' }
        , { 'name': 'South Africa', 'abbrev': 'ZAF' }
        , { 'name': 'Sudan', 'abbrev': 'SDN' }
        , { 'name': 'Sweden', 'abbrev': 'SWE' }
        , { 'name': 'Switzerland', 'abbrev': 'CHE' }
        , { 'name': 'Suriname', 'abbrev': 'SUR' }
        , { 'name': 'Svalbard and Jan Mayen', 'abbrev': 'SJM' }
        , { 'name': 'Swaziland', 'abbrev': 'SWZ' }
        , { 'name': 'Tajikistan', 'abbrev': 'TJK' }
        , { 'name': 'Thailand', 'abbrev': 'THA' }
        , { 'name': 'Taiwan', 'abbrev': 'TWN' }
        , { 'name': 'Tanzania', 'abbrev': 'TZA' }
        , { 'name': 'British Indian Ocean Territory', 'abbrev': 'IOT' }
        , { 'name': 'French Southern Territories', 'abbrev': 'ATF' }
        , { 'name': 'East Timor', 'abbrev': 'TLS' }
        , { 'name': 'Togo', 'abbrev': 'TGO' }
        , { 'name': 'Tokelau', 'abbrev': 'TKL' }
        , { 'name': 'Tonga', 'abbrev': 'TON' }
        , { 'name': 'Trinidad and Tobago', 'abbrev': 'TTO' }
        , { 'name': 'Tunisia', 'abbrev': 'TUN' }
        , { 'name': 'Turkmenistan', 'abbrev': 'TKM' }
        , { 'name': 'Turkey', 'abbrev': 'TUR' }
        , { 'name': 'Tuvalu', 'abbrev': 'TUV' }
        , { 'name': 'Ukraine', 'abbrev': 'UKR' }
        , { 'name': 'Uganda', 'abbrev': 'UGA' }
        , { 'name': 'Uruguay', 'abbrev': 'URY' }
        , { 'name': 'Uzbekistan', 'abbrev': 'UZB' }
        , { 'name': 'Vanuatu', 'abbrev': 'VUT' }
        , { 'name': 'Venezuela', 'abbrev': 'VEN' }
        , { 'name': 'Vietnam', 'abbrev': 'VNM' }
        , { 'name': 'Wallis and Futuna', 'abbrev': 'WLF' }
        , { 'name': 'Yemen', 'abbrev': 'YEM' }
        , { 'name': 'Djibouti', 'abbrev': 'DJI' }
        , { 'name': 'Zambia', 'abbrev': 'ZMB' }
        , { 'name': 'Zimbabwe', 'abbrev': 'ZWE' }
      ];
    }

  }

  scrolling(position) {

    if (location.pathname.substr(1) == "home" || location.pathname.substr(1) == "index") {
      var elmnt = document.getElementById(position);
      elmnt.scrollIntoView({ behavior: 'smooth' });
    } else {
      var myurl = position;
      this.router.navigateByUrl('/home').then(e => {
        if (e) {
          var element = document.getElementById(position);
          element.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }
  logout() {
    this.auth.logout();
  }
  getUser() {
    if (localStorage.getItem('user')) {
      this.user = new UserModel(JSON.parse(localStorage.getItem('user')));
    } else {
      return false;
    }
  }

  disableCookiesPtl(){
    this.commonHelper.disableCookiesPtl();
  }


  //login social media
  async signInWithApple() {
    window.open(
      'https://appleid.apple.com/auth/authorize?redirect_uri=https://api.extrabase.tv/users/middleware&response_type=code%20id_token&client_id=com.somosmultimedia.extrabase&scope=name%20email&response_mode=form_post',
      '_self'
    );
  };

  fbLibrary() {
    (window as any).fbAsyncInit = function () {
      window['FB'].init({
        appId: '2294170240821995',
        xfbml: true,
        version: 'v12.0'
      });
      window['FB'].AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }

  loginFb() {
    window['FB'].login((response) => {
      if (response.authResponse) {
        window['FB'].api('/' + response.authResponse.userID + '/?fields=id,email,name,first_name,last_name,address', ['public_profile', 'email'], {
          fields: 'id,email,name,first_name,last_name,address'
        }, (userInfo) => {
          const formData = new FormData();
          formData.append('id', userInfo.id);
          formData.append('email', userInfo.email);
          formData.append('first_name', userInfo.first_name);
          formData.append('last_name', userInfo.last_name);
          this.auth.facebookLogin(formData).toPromise().then(rest => {
            window.location.href = '/home';
          }).catch(err => {
            var message = "";
            switch (err.status) {
              case 401:
                message = this.commonHelper.getTranslation('errors.emailIsRegistered');
                break;

              default:
                message = this.commonHelper.getTranslation('errors.serverError');
                break;
            }
            Swal.fire({
              type: 'error',
              title: 'Iniciar con Facebook',
              text: message
            });
          })
        });

      } else {
        console.log('User login failed');
      }
    }, { scope: 'email' });
  }

}
